import React, { Component } from "react";
import { Card, CardBody } from "reactstrap";
import ReportFooter from "./ReportFooter";
import ReportHeader from "./ReportHeader";
import ReportHeader_Swiss from "./ReportHeader_Swiss";
import ReportFooter_Swiss from "./ReportFooter_Swiss";

const allPreDamageImagesArr = [
  { id: 1, name: "svg_Hood" },
  { id: 2, name: "svg_LeftFrontFender" },
  { id: 3, name: "svg_RightFrontFender" },
  { id: 4, name: "svg_LeftFrontDoor" },
  { id: 5, name: "svg_RightFrontDoor" },
  { id: 6, name: "svg_LeftBackDoor" },
  { id: 7, name: "svg_RightBackDoor" },
  { id: 8, name: "svg_LeftBackFender" },
  { id: 9, name: "svg_RightBackFender" },
  { id: 10, name: "svg_Trunk" },
  { id: 11, name: "svg_TrunkCover" },
  { id: 12, name: "svg_Roof" },
  { id: 13, name: "svg_LeftRoofFrame" },
  { id: 14, name: "svg_RightRoofFrame" },
  { id: 15, name: "svg_SideFenderTurnSignalRepeaterLampL" },
  { id: 16, name: "svg_FenderTrimPlateFL" },
  { id: 17, name: "svg_DecorStickerOfRoofFrameL" },
  { id: 18, name: "svg_SideViewMirrorL" },
  { id: 19, name: "svg_SideMirrorRepeaterLampL" },
  { id: 20, name: "svg_OuterUpperDoorWindowTrim_Crom_FL" },
  { id: 21, name: "svg_UprightOuterDoorCover_PlateFL" },
  { id: 22, name: "svg_OuterLowerDoorWindowSlotSeal_Crom_FL" },
  { id: 23, name: "svg_SideWindowFL" },
  { id: 24, name: "svg_DoorHandleFL" },
  { id: 25, name: "svg_Rocker_RunningPanelFL_DecorStrip" },
  { id: 26, name: "svg_UprightOuterDoorCover_PlateFirstOneBL" },
  { id: 27, name: "svg_OuterUpperDoorWindowTrim_Crom_BL" },
  { id: 28, name: "svg_UprightOuterDoorCover_PlateSecondOneBL" },
  { id: 29, name: "svg_OuterLowerDoorWindowSlotSeal_Crom_BL" },
  { id: 30, name: "svg_SideWindowBL" },
  { id: 31, name: "svg_DoorHandleBL" },
  { id: 32, name: "svg_Rocker_RunningPanelBL_DecorStrip" },
  { id: 33, name: "svg_QuarterWindowBL" },
  { id: 34, name: "svg_QuarterWindowTrim_Crom_BL" },
  { id: 35, name: "svg_FuelTankDoor" },
  { id: 36, name: "svg_FenderTrimPlateBL" },
  { id: 37, name: "svg_TailLightOuterL" },
  { id: 38, name: "svg_RearWindshieldDecorTrimL" },
  { id: 39, name: "svg_FogLightL" },
  { id: 40, name: "svg_FogLightR" },
  { id: 41, name: "svg_HeadlightL" },
  { id: 42, name: "svg_HeadlightR" },
  { id: 43, name: "svg_RadiatorGrille" },
  { id: 44, name: "svg_HoodEmblem" },
  { id: 45, name: "svg_CoverForPlenumChamberL" },
  { id: 46, name: "svg_CoverForPlenumChamberR" },
  { id: 47, name: "svg_WindshieldWiperL_ArmCap" },
  { id: 48, name: "svg_WindshieldWiperR_ArmCap" },
  { id: 49, name: "svg_Windshield" },
  { id: 50, name: "svg_WindshieldDecorTrimL" },
  { id: 51, name: "svg_WindshieldDecorTrimR" },
  { id: 52, name: "svg_RoofDripMoldingL" },
  { id: 53, name: "svg_RoofDripMoldingR" },
  { id: 54, name: "svg_SunRoof" },
  { id: 55, name: "svg_RoofRailL" },
  { id: 56, name: "svg_RoofRailR" },
  { id: 57, name: "svg_Antenna" },
  { id: 58, name: "svg_TrunckCover_Spoiler" },
  { id: 59, name: "svg_HighMountStopLight" },
  { id: 60, name: "svg_RearWindshield" },
  { id: 61, name: "svg_WiperForRearWindshield_ArmCap" },
  { id: 62, name: "svg_TrunkEmblem" },
  { id: 63, name: "svg_Emblem" },
  { id: 64, name: "svg_TailLightInnerL" },
  { id: 65, name: "svg_TailLightInnerR" },
  { id: 66, name: "svg_SideFenderTurnSignalRepeaterLampR" },
  { id: 67, name: "svg_FenderTrimPlateFR" },
  { id: 68, name: "svg_DecorStickerOfRoofFrameR" },
  { id: 69, name: "svg_SideViewMirrorR" },
  { id: 70, name: "svg_SideMirrorRepeaterLampR" },
  { id: 71, name: "svg_OuterUpperDoorWindowTrim_Crom_FR" },
  { id: 72, name: "svg_UprightOuterDoorCover_PlateFR" },
  { id: 73, name: "svg_OuterLowerDoorWindowSlotSeal_Crom_FR" },
  { id: 74, name: "svg_SideWindowFR" },
  { id: 75, name: "svg_DoorHandleFR" },
  { id: 76, name: "svg_Rocker_RunningPanelFR_DecorStrip" },
  { id: 77, name: "svg_UprightOuterDoorCover_PlateFirstOneBR" },
  { id: 78, name: "svg_OuterUpperDoorWindowTrim_Crom_BR" },
  { id: 79, name: "svg_UprightOuterDoorCover_PlateSecondOneBR" },
  { id: 80, name: "svg_OuterLowerDoorWindowSlotSeal_Crom_BR" },
  { id: 81, name: "svg_SideWindowBR" },
  { id: 82, name: "svg_DoorHandleBR" },
  { id: 83, name: "svg_Rocker_RunningPanelBR_DecorStrip" },
  { id: 84, name: "svg_QuarterWindowBR" },
  { id: 85, name: "svg_QuarterWindowTrim_Crom_BR" },
  { id: 86, name: "svg_FenderTrimPlateBR" },
  { id: 87, name: "svg_TailLightOuterR" },
  { id: 88, name: "svg_RearWindshieldDecorTrimR" },
  { id: 89, name: "svg_FrontBumper" },
  { id: 90, name: "svg_LeftFrontTyre" },
  { id: 91, name: "svg_LeftBackTyre" },
  { id: 92, name: "svg_RightFrontTyre" },
  { id: 93, name: "svg_RightBackTyre" },
  { id: 94, name: "svg_BackBumper" }
];

export class PreDamageImages extends Component {
  lang = (word) => {
    const { lang, words } = this.props;
    return words[word] ? words[word][lang] : word;
  };

  getOrderno = (part) => {
    const order = allPreDamageImagesArr.find(
      (item) => item.name === part
    );
    return order
  };

  render() {
    const { preDamageImagesArr, PreDamage } = this.props;
    const client = localStorage.getItem("client")
    return (
      <>
        {(preDamageImagesArr.length && PreDamage == 1)
          ? preDamageImagesArr.map((data, i) => {
              return (
                <div
                  className="row row-zero page-break-row report-full-wrapper"
                  data-content-name={this.lang("Page")}
                  key={i}
                >
                  <div className="col-sm-12 full-height-col col-zero">
                    <Card>
                      <CardBody className="col-zero">
                        <div className="newFormatReport_wrapper">
                          <ReportHeader_Swiss />
                          <div className="container">
                            <div className="row title-row-main">
                              <div className="col-sm-12 col-zero">
                                <h3 className="report-title">
                                  <span> {this.lang("pre-Damage")}</span>{" "}
                                </h3>
                              </div>
                            </div>
                            <div className="all_photo_images">
                              {data.map((inner_data, inner_i) => {
                                return (
                                  <React.Fragment key={inner_i}>
                                    <div className="row left-side-row">
                                      {inner_data.length > 0 &&
                                        inner_data.map((r, photo_i) => {

                                          const parts =
                                            r && r.part ? r.part.split("_") : [];
                                          const [first, ...rest] = parts;
                                          const combinedRest = rest.join("_");

                                          const name = [first, combinedRest];
                                          const partNo =
                                            r && r.part.split("-")[2];
                                          const isDamage =
                                            r && r.part.includes("Damage");
                                            const partDetails = this.getOrderno(r && r.part)
                                          return r ? (
                                            <div
                                              className="col-lg-6 col-md-6 col-sm-12 col-zero"
                                              key={photo_i}
                                            >
                                              <div className="row row-zero photo_gallery_border_row">
                                                <div className="col-sm-12 photo_gallery_border_col">
                                                  <div className="photo_gallery_img">
                                                    <img src={r.name} alt="" />
                                                    <p className="photo_gallery_text">
                                                      
                                                      {isDamage
                                                        ? this.lang("Damage") -
                                                          partNo
                                                        : partDetails && partDetails.id && partDetails.id + ". " + this.lang(name[1]) ||
                                                          this.lang(r.part)}
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ) : null;
                                        })}
                                    </div>
                                  </React.Fragment>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </CardBody>
                      <ReportFooter_Swiss reportType="newReportFull" />
                    </Card>
                  </div>
                </div>
              );
            })
          : null}
      </>
    );
  }
}

export default PreDamageImages;
